<template>
  <div class="lesson-section-html" v-html="data.text" />
</template>

<script>
import typesetMathMlMixin from '../../../mixins/typeset-mathml'
import textToSpeechMixin from '../../../mixins/inject-text-to-speech'

export default {
  name: 'LessonSectionVideo',
  mixins: [textToSpeechMixin, typesetMathMlMixin],
  props: { data: Object },
  mounted() {
    this.parseExamples()
    this.injectTextToSpeech(this.$el)
  },
  methods: {
    /**
     * Parses the DOM for example paragraphs and wraps groups of example paragraphs in example divs.
     * @private
     */
    parseExamples() {
      // Find all p-tags within this.dom
      const examples = this.$el.querySelectorAll('p')

      // For each p-tag ...
      Array.from(examples).forEach(pTag => {
        // ... check if it's an example p-tag
        if (
          pTag.classList.contains('example') ||
          pTag.classList.contains('example-indent')
        ) {
          // If it is, we need to add it in an example div.

          // Get the previous sibling
          let prevSibling = pTag.previousElementSibling

          if (!prevSibling) {
            prevSibling = pTag.parentNode
          }

          // If this element is not already an example div...
          if (
            prevSibling.tagName !== 'DIV' ||
            !prevSibling.classList.contains('example')
          ) {
            // ... create it ...
            const div = document.createElement('div')

            div.className = 'example'

            // ... add it as the previous sibling ...
            pTag.parentNode.insertBefore(div, pTag)

            prevSibling = div
          }

          prevSibling.appendChild(pTag)
        }
      })
    },
  },
}
</script>

<style lang="scss">
/*
 * All of these selectors are for elements and class names defined by the WYSIWYG in CAD.
 */
.lesson-section-html {
  h3 {
    font-size: 1.2em;
    margin: 1em 7.5% 0;
    padding-bottom: 0.3em;
  }

  p {
    &.paragraph-indent,
    &.example-indent {
      margin-left: 7%;
    }
  }

  div.example {
    background-color: $infoBackground;
    border-radius: $borderRadiusSmall;
    padding: 0.5em 1em;
    margin: 0.3em 7% 1.7em;
    line-height: 19px;
  }

  .text_indent {
    margin-left: 7%;
  }

  .example_text {
    padding: 0.5em 0 0.8em;
  }

  .example_text_indent {
    color: #fff;
    margin-left: 7%;
  }

  @media (max-width: 60em) {
    h3 {
      margin: 1em 3.5% 0;
    }

    div.example {
      margin-left: 3%;
      margin-right: 3%;
    }

    .text_indent,
    .example_text_indent {
      margin-left: 3%;
    }
  }

  @media (max-width: 45em) {
    h3 {
      margin: 1em 0 0;
    }

    div.example {
      margin-left: 0;
      margin-right: 0;
    }
  }

  @media (max-width: 30em) {
    div.example {
      // Make the examples fill the entire width of the screen
      margin-left: -1em;
      margin-right: -1em;
      border-radius: 0;
    }
  }

  @media (max-width: 40em) {
    // Trim down padding
    padding-left: 1em;
    padding-right: 1em;
  }

  @media (min-width: 70em) {
    // Increase readability by shortening the line lengths
    padding-right: 5em;
  }
}
</style>
